import styled from '@emotion/styled';

export const StyledLabel = styled('label')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: 4,
  gap: 8,
  boxSizing: 'border-box',

  '&[data-disabled="true"]': {
    opacity: 0.5,
    pointerEvents: 'none',
  },
});

export const StyledLeft = styled('span')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  gap: 4,
  minWidth: 0,
});

export const StyledTooltipTrigger = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'help',
  flexShrink: 0,
  color: theme.colors.text.secondary,
}));
